<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path d="m19 13h-14v-2h14z" />
  </svg>
</template>
